import * as React from 'react'

export function DetailsIcon({ ...props }) {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M23.7692 44.2422C16.5006 44.2422 11 41.727 11 38.438C11 35.1489 16.5006 32.6338 23.7692 32.6338C31.0379 32.6338 36.5385 35.1489 36.5385 38.438C36.5385 41.727 31.0379 44.2422 23.7692 44.2422ZM23.7692 34.5685C17.5811 34.5685 12.9645 36.6 12.9645 38.438C12.9645 40.276 17.5811 42.3074 23.7692 42.3074C29.9574 42.3074 34.574 40.276 34.574 38.438C34.574 36.6 29.9574 34.5685 23.7692 34.5685Z"
        fill="#4383CC"
      />
      <path
        d="M35.7661 15.6747C35.7661 22.0958 23.7707 38.0513 23.7707 38.0513C23.7707 38.0513 11.7754 22.0958 11.7754 15.6747C11.7754 9.25363 17.1733 4 23.7707 4C30.3682 4 35.7661 9.25363 35.7661 15.6747Z"
        fill="#0E4686"
      />
      <g clipPath="url(#clip0_6785_76974)">
        <path
          d="M27.8579 14.6439L28.6912 12.8105L30.5246 11.9772L28.6912 11.1439L27.8579 9.31055L27.0246 11.1439L25.1912 11.9772L27.0246 12.8105L27.8579 14.6439ZM22.8579 14.9772L21.1912 11.3105L19.5246 14.9772L15.8579 16.6439L19.5246 18.3105L21.1912 21.9772L22.8579 18.3105L26.5246 16.6439L22.8579 14.9772ZM27.8579 18.6439L27.0246 20.4772L25.1912 21.3105L27.0246 22.1439L27.8579 23.9772L28.6912 22.1439L30.5246 21.3105L28.6912 20.4772L27.8579 18.6439Z"
          fill="#A1C1E6"
        />
      </g>
      <defs>
        <clipPath id="clip0_6785_76974">
          <rect
            width="16"
            height="16"
            fill="white"
            transform="translate(15.1914 8.64355)"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
